import BusinessIcon from '@mui/icons-material/Business';
import HouseIcon from '@mui/icons-material/House';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';

import { Customer, Location } from '_lib/api/apiTypes.shim';

import { FieldSet } from '_lib/components/FieldSet/FieldSet';
import { Stack } from '_lib/components/Stack/Stack';
import { Typography } from '_lib/components/Typography/Typography';
import { customerDisplayName, formatAddressOneLine } from '_lib/utils/helpers';

interface CustomerInformationProps {
  customer: Customer;
  location: Location | null;
}

export const CustomerInformation = (props: CustomerInformationProps) => {
  const { customer, location } = props;

  return (
    <FieldSet legendText='Customer Info'>
      <Stack>
        <Stack direction='row' sx={{ alignItems: 'center' }}>
          <PersonIcon />
          <Typography text={customerDisplayName(customer)} />
        </Stack>
        {location && (
          <Stack direction='row' sx={{ alignItems: 'center' }}>
            {customer.isCommercial ? <BusinessIcon /> : <HouseIcon />}
            <Typography sx={{ whiteSpace: 'pre-line' }} text={`${location.name}\n ${formatAddressOneLine(location)}`} />
          </Stack>
        )}
      </Stack>
    </FieldSet>
  );
};
